export enum PoiValidatorsPoiStatus{
    approved = 1,
    pending = 2,
    denied = 3,
    deleted = 4,
    expired = 5,
    approvalOverride = 6
}